import { __decorate, __metadata, __param } from "tslib";
import { Inject, Injectable } from 'angular-ts-decorators';
var baseUrl = '/support/api/product-filter-module';
var ProductFilterModuleApiService = (function () {
    function ProductFilterModuleApiService($http) {
        this.$http = $http;
    }
    ProductFilterModuleApiService.prototype.getConfiguration = function (id) {
        return this.$http
            .get(baseUrl + "/" + id)
            .then(function (response) { return response.data; });
    };
    ProductFilterModuleApiService.$inject = ['$http'];
    ProductFilterModuleApiService = __decorate([
        Injectable('productFilterModuleApiService'),
        __param(0, Inject('$http')),
        __metadata("design:paramtypes", [Function])
    ], ProductFilterModuleApiService);
    return ProductFilterModuleApiService;
}());
export { ProductFilterModuleApiService };
